/**
 * @module builder
 */
export function getEntityTypeOptions() {
  return ['areas', 'lineItems', 'substrates', 'groups']
}
